// extracted by mini-css-extract-plugin
export default {"breadcrumb":"[id]_breadcrumb__UEOSG","scrollContainer":"[id]_scrollContainer__fSrk8","scrollSection":"[id]_scrollSection__6Dmms"};